import React from "react";
import { translateManeuver } from "../MapBox/MapBoxFeatures/CompileProject";
import { removeHtmlTags } from "../../util/Util";
import { useTranslation } from "react-i18next";
import { indicationTypes } from "../GPX/Resources";

function EditStepForm({
  step,
  divRef,
  newMessage,
  newStepType,
  checkAudio,
  setCheckAudio,
  setNewMessage,
  setNewStepType,
  newStepDistance,
  setNewStepCoordinates,
  handleEdit,
  stopEdit,
  updateStepDistance,
  setDistanceIsModified,
}) {
  const { t } = useTranslation();
  return (
    <div ref={divRef} className="formCustomDirections">
      <input
        className="inputCustomDirections"
        defaultValue={
          newMessage ? newMessage : removeHtmlTags(step.instructions)
        }
        onChange={(e) => setNewMessage(e.target.value)}
        data-testid="instruction"
      ></input>
      <input
        className="inputCustomDirections"
        value={newStepDistance.text}
        placeholder={t("triggerDistance")}
        onChange={(e) => {
          updateStepDistance(e);
          setDistanceIsModified(true);
        }}
        data-testid="distance"
      />
      <div className="form-group">
        <select
          className="selectCustomDirections"
          defaultValue={step.maneuver ? step.maneuver : newStepType}
          onChange={(e) => setNewStepType(e.target.value)}
          data-testid="select-type"
        >
          <option value="">
            {translateManeuver(step.maneuver, step.instructions)}
          </option>

          {indicationTypes.map((option, index) => (
            <option key={index} value={option}>
              {option === "Gauche" && t("left")}
              {option === "Droite" && t("right")}
              {option === "Tout droit" && t("ahead")}
              {option === "Retour" && t("return")}
              {option === "Déviation à droite" && t("deviationRight")}
              {option === "Déviation à gauche" && t("deviationLeft")}
              {option === "Continuer vers la droite" && t("continueRight")}
              {option === "Continuer vers la gauche" && t("continueLeft")}
              {option === "Continuer tout droit" && t("straightAhead")}
              {option === "1ère sortie" && t("1stExit")}
              {option === "2ème sortie" && t("2thExit")}
              {option === "3ème sortie" && t("3thExit")}
              {option === "4ème sortie" && t("4thExit")}
              {option === "5ème sortie" && t("5thExit")}
              {option === "Restez à droite" && t("stayRight")}
              {option === "Restez à gauche" && t("stayLeft")}
              {option === "Légèrement à droite" && t("slightlyRight")}
              {option === "Légèrement à gauche" && t("slightlyLeft")}
              {option === "Tourner carrément à droite" && t("sharplyRight")}
              {option === "Tourner carrément à gauche" && t("sharplyLeft")}
              {option === "Audio" && t("audio")}
            </option>
          ))}
        </select>
      </div>
      <input
        className="inputCustomDirections"
        defaultValue={step.start_location}
        onChange={(e) => setNewStepCoordinates(e.target.value)}
      />
      <div className="d-flex justify-content-around m-2">
        <div className="form-check form-switch m-2">
          <input
            className="form-check-input"
            type="checkbox"
            checked={checkAudio !== undefined ? checkAudio : step.checkAudio}
            onChange={() => setCheckAudio((prev) => !prev)}
            data-testid="Audio"
          />

          <label className="form-check-label text-white">Audio</label>
        </div>
        <button
          className="validateCustomDirections"
          onClick={() => {
            handleEdit();
          }}
        >
          {t("accept")}
        </button>
        <button
          className="cancelCustomDirections"
          onClick={() => {
            stopEdit();
          }}
        >
          {t("cancel")}
        </button>
      </div>
    </div>
  );
}

export default EditStepForm;
